module.exports = __webpack_public_path__ + "assets/images/close-circle9506aca0ae99e83f77597b74cd702916.svg";